// NotFound — 404 page.
//
// Mounted twice in router.tsx (audit-pass-5 UI #23):
//   - Inside the authed App shell so logged-in operators who land on a
//     bad URL see the sidebar + topbar context, not a blank standalone
//     viewport that looks like they were logged out.
//   - At the root level for unauthed visitors (RequireAuth bounces them
//     through /login if they're hitting a protected path).
//
// The same component handles both — wrapping in `.page` lets the App
// shell's grid place it correctly. minHeight: 60vh keeps the
// vertical-center feel without overflowing past the topbar on either
// mount path.
import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="page">
      <div
        style={{
          minHeight: "60vh",
          display: "grid",
          placeItems: "center",
          textAlign: "center",
        }}
      >
        <div className="stack-12">
          <div className="eyebrow">404</div>
          <h1 style={{ fontSize: 28, letterSpacing: "-0.02em" }}>Not found</h1>
          <p className="dim" style={{ fontSize: 13 }}>
            We couldn’t find that page in the go-pim console.
          </p>
          <Link to="/" className="btn">
            Back to overview
          </Link>
        </div>
      </div>
    </div>
  );
}
